import axios from 'axios';
import { connect } from 'react-redux'
import * as RX from 'reactxp';
import ButtonLink from '../../components/button_link';
import ButtonSet from '../../components/button_set';
import MultiTextInput from '../../components/multi_text_input';
import OutlineBox from '../../components/outline_box';

import * as ReactGA from '../../modules/google_analytics';
import { symptomDiagnosis } from '../../utils/api';
import t from '../../utils/i18n'
import { mapStateToProps } from '../../utils/mapper';
import { body, colors, h1, h2, subHeader } from '../../utils/styles';

import CryingFace from '../../modules/svgs/crying_face';
import HappyFace from '../../modules/svgs/happy_face';
import MediumFace from '../../modules/svgs/medium_face';
import SadFace from '../../modules/svgs/sad_face';

import DatePicker from '../../modules/date_picker';
import { openUrl } from '../../modules/links';
import { Link, Redirect } from '../../modules/routing';

import * as moment from 'moment';

const styles = {
    alert: RX.Styles.createViewStyle({
        backgroundColor: colors.white,
        borderColor: colors.grey,
        borderWidth: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        minWidth: 300,
        position: 'absolute',
    }),
    header: RX.Styles.createTextStyle({
        color: colors.header,
        textAlign: 'left',
    }),
    label: RX.Styles.createTextStyle({
        color: colors.grey,
        marginBottom: 12,
        marginTop: 16,
    }),
    sectionHeader: RX.Styles.createTextStyle({
        color: 'black',
        marginBottom: 4
    }),
};

interface Form {
    dob: any;
    [key: string]: number | string | any;
    validated: boolean;
    redirect?: boolean;
};
interface SymptomCheckerProps {
    dispatch: ({ type }: { type: string, [key: string]: any }) => void;
    window: { multiplier: number, width: number };
    [key: string]: any;

    showControlsError: boolean;
};
const initialState = {
    dob: '',
    showControlsError: false,
    validated: false,
}
class SymptomChecker extends RX.Component<SymptomCheckerProps, RX.CommonProps & Form> {

    constructor(props: SymptomCheckerProps) {
        super(props);
        this.state = props.symptom.modifying ? {
            ...initialState,
            ...props.symptom,
        } : { ...initialState };

        this.handleChange = this.handleChange.bind(this);
        this.valueChange = this.valueChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.clearForm = this.clearForm.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.sliderChange = this.sliderChange.bind(this);
        this.timedOut = this.timedOut.bind(this);

        props.dispatch({ type: 'MODIFYING', modify: false });
    }

    public componentDidMount() {
        this.props.dispatch({ type: 'SHOULD_SCROLL' });
        ReactGA.trackEvent(
            'Go to SymptomChecker',
            'Navigation',
        );
    }

    public componentWillUnmount() {
        this.props.dispatch({ type: 'SHOULD_SCROLL' });
    }

    public render() {
        const years = moment().diff(this.state.dob, 'years');
        const showPregnancy = years >= 12 && years <= 65;

        const { window: { multiplier } } = this.props;

        if (this.state.redirect) {
            return <Redirect to='/results' />
        }
        const resetStyle = RX.Platform.getType() !== 'web'
            ? { maxWidth: 100 * multiplier }
            : { fontSize: 14 * multiplier, textDecorationLine: 'underline', maxWidth: 100 * multiplier }
        // tslint:disable:max-line-length
        return (
            <RX.View>
                <RX.Text style={[h1(multiplier), styles.header]}>{t('symptomChecker.header')}</RX.Text>
                <RX.View style={{ marginBottom: 12 * multiplier, marginTop: 12 * multiplier }}>
                    <RX.Text style={body(multiplier)}>{t('symptomChecker.subheader')}</RX.Text>
                </RX.View>
                <RX.View style={{ marginBottom: 8 * multiplier }}>
                    <RX.Text style={{ fontSize: 12 * multiplier, color: colors.menuRed, fontStyle: 'italic' }}>
                        {t('symptomChecker.requiredField')}
                    </RX.Text>
                </RX.View>
                <OutlineBox>
                    <RX.Text style={[h2(multiplier)]}>{t('symptomChecker.basicSection.header')}</RX.Text>
                    <RX.Text id='DatePickerLabel' style={[subHeader(multiplier), styles.label]}>{t('symptomChecker.basicSection.dateOfBirth')}{(!this.state.dob || years < 1) && <RX.Text style={{ color: colors.alert }}> *</RX.Text>}</RX.Text>
                    {!this.state.dob && this.state.showControlsError && <RX.Text style={{ color: colors.alert, fontWeight: 'bold', fontSize: 16 * multiplier  }}>This field is required.</RX.Text>}
                    <DatePicker
                        showError={!this.state.dob && this.state.showControlsError}
                        onChange={this.handleChange}
                        date={this.state.dob}
                        {... { multiplier }}
                    />
                    <ButtonSet
                        showError={!this.state.sex && this.state.showControlsError}
                        active={this.state.sex || ''}
                        label={t('symptomChecker.basicSection.gender.label')}
                        labelId='sex'
                        onChange={({ value }: { value: any }) => this.valueChange({ value, key: 'sex' })}
                        options={[{ label: 'Male', value: 1 }, { label: 'Female', value: 2 }]}
                    />
                    {this.state.sex === 2 && showPregnancy &&
                        <ButtonSet
                            required={false}
                            active={this.state.pregnancy || ''}
                            label='Pregnant?'
                            labelId='pregnant'
                            options={[{ label: 'Yes', value: 1 }, { label: 'No', value: 2 }]}
                            onChange={({ value }: { value: any }) => this.valueChange({ value, key: 'pregnancy' })}
                        />}
                    <MultiTextInput
                        showError={!this.state.text && this.state.showControlsError}
                        moreSpace={this.state.sex === 2 && showPregnancy}
                        values={this.state.text || []}
                        onChange={({ value }: { value: any }) => this.valueChange({ value, key: 'text' })}
                        label={t('symptomChecker.basicSection.symptoms')} />
                    <RX.View style={{borderWidth: .5, marginBottom: 40, marginTop: 40, borderColor: '#aaa' }} />
                    <RX.Text style={[h2(multiplier)]}>{t('symptomChecker.severitySection.header')}</RX.Text>
                    <ButtonSet
                        showError={!this.state.Q1 && this.state.showControlsError }
                        active={this.state.Q1 || ''}
                        label={t('symptomChecker.severitySection.quickness.label')}
                        labelId='Q1'
                        options={[
                            { label: t('symptomChecker.severitySection.quickness.options.minutes'), value: 1 },
                            { label: t('symptomChecker.severitySection.quickness.options.days'), value: 2 },
                            { label: t('symptomChecker.severitySection.quickness.options.weeks'), value: 3 },
                            { label: t('symptomChecker.severitySection.quickness.options.months'), value: 4 }
                        ]}
                        onChange={({ value }: { value: any }) => this.valueChange({ value, key: 'Q1' })}
                    />
                    <ButtonSet
                        showError={!this.state.Q2 && this.state.showControlsError}
                        active={this.state.Q2 || ''}
                        label={t('symptomChecker.severitySection.length.label')}
                        labelId='Q2'
                        options={[
                            { label: t('symptomChecker.severitySection.length.options.days'), value: 1 },
                            { label: t('symptomChecker.severitySection.length.options.weeks'), value: 2 },
                            { label: t('symptomChecker.severitySection.length.options.months'), value: 3 }
                        ]}
                        onChange={({ value }: { value: any }) => this.valueChange({ value, key: 'Q2' })}
                    />
                    <ButtonSet
                        showError={!this.state.Q3 && this.state.showControlsError}
                        active={this.state.Q3 || ''}
                        label={t('symptomChecker.severitySection.change.label')}
                        labelId='Q3'
                        options={[
                            { label: t('symptomChecker.severitySection.change.options.better'), value: 1 },
                            { label: t('symptomChecker.severitySection.change.options.same'), value: 2 },
                            { label: t('symptomChecker.severitySection.change.options.worse'), value: 3 }
                        ]}
                        onChange={({ value }: { value: any }) => this.valueChange({ value, key: 'Q3' })}
                    />
                    <ButtonSet
                        showError={!this.state.Q4 && this.state.showControlsError}
                        active={this.state.Q4 || ''}
                        label={t('symptomChecker.severitySection.discomfort.label')}
                        labelId='Q4'
                        options={[
                            { label: t('painSlider.levels.none'), value: 1, svg: HappyFace },
                            { label: t('painSlider.levels.mild'), value: 2, svg: MediumFace },
                            { label: t('painSlider.levels.severe'), value: 3, svg: SadFace },
                            { label: t('painSlider.levels.worst'), value: 4, svg: CryingFace }
                        ]}
                        onChange={({ value }: { value: any }) => this.valueChange({ value, key: 'Q4' })}
                    />
                    <ButtonSet
                        showError={!this.state.Q5 && this.state.showControlsError}
                        active={this.state.Q5 || ''}
                        label={t('symptomChecker.severitySection.dailyActivities.label')}
                        labelId='Q5'
                        options={[
                            { label: t('symptomChecker.severitySection.dailyActivities.options.none'), value: 1 },
                            { label: t('symptomChecker.severitySection.dailyActivities.options.struggle'), value: 2 },
                            { label: t('symptomChecker.severitySection.dailyActivities.options.unable'), value: 3 },
                        ]}
                        onChange={({ value }: { value: any }) => this.valueChange({ value, key: 'Q5' })}
                    />
                    <ButtonSet
                        showError={!this.state.Q6 && this.state.showControlsError}
                        active={this.state.Q6 || ''}
                        label={t('symptomChecker.severitySection.medication.label')}
                        labelId='Q6'
                        options={[
                            { label: t('symptomChecker.severitySection.medication.options.notTaking'), value: 1 },
                            { label: t('general.yes'), value: 2 },
                            { label: t('general.no'), value: 3 }
                        ]}
                        onChange={({ value }: { value: any }) => this.valueChange({ value, key: 'Q6' })}
                    />
                    <ButtonSet
                        showError={!this.state.Q7 && this.state.showControlsError}
                        active={this.state.Q7 || ''}
                        label={t('symptomChecker.severitySection.otherConditions.label')}
                        labelId='Q7'
                        options={[
                            { label: t('general.yes'), value: 2 },
                            { label: t('general.no'), value: 1 }
                        ]}
                        onChange={({ value }: { value: any }) => this.valueChange({ value, key: 'Q7' })}
                    />
                    <ButtonLink
                        // disabled={!this.state.validated}
                        text={t('symptomChecker.showResults')}
                        dark
                        onPress={this.submitForm}
                    />
                    <Link
                        to='/symptom-checker'
                        replace
                        // onPress={this.clearForm}
                        onClick={this.clearForm}
                        style={resetStyle}
                    >
                        <RX.Text style={{ textDecorationLine: 'underline' }}>{t('symptomChecker.resetForm')}</RX.Text>
                    </Link>
                </OutlineBox>
            </RX.View>
        );
    }

    private clearForm() {
        this.props.dispatch({ type: 'CLEAR_VALUES' });
        this.setState({
            Q1: '',
            Q2: '',
            Q3: '',
            Q4: '',
            Q5: '',
            Q6: '',
            Q7: '',
            dob: '',
            pregnancy: '',
            sex: '',
            showControlsError: false,
            text: [],
            validated: false,
        });
        document.getElementById('DatePickerLabel');
    }

    private handleChange(date: any) {
        if (!date) {
            this.setState({
                dob: date,
            });
            this.validateForm({ ...this.state, dob: date });

            return;
        }

        const momentDate = typeof date === 'string' ? moment(date, 'MM-DD-YYYY') : date;
        const years = moment().diff(momentDate, 'years');
        const days = moment().diff(momentDate, 'days');
        const { window: { multiplier, width } } = this.props;

        (years <= 0) && this.props.dispatch({
            children: <RX.Text style={{ maxWidth: width - 16 * multiplier, fontSize: 14 * multiplier }}>
                {
                    t('symptomChecker.callPhysician')
                }</RX.Text>,
            type: 'SHOW_POPUP'
        }); //tslint:disable-line
        this.setState({
            dob: years <= 0 ? '' : momentDate, // dob: momentDate,
        });

        this.validateForm({ ...this.state, dob: momentDate });
    }

    private valueChange({ key, value }: { key: string, value: string | number }) {
        this.setState({ [key]: value });
        this.validateForm({ ...this.state, [key]: value });
    }

    private sliderChange(value: number) {
        this.setState({ Q4: value });
        this.validateForm({ ...this.state, Q4: value });
    }

    private submitForm() {
        const { dispatch, scroll: { scroller } } = this.props;
        const years = moment().diff(this.state.dob, 'years');
        const moreSpace = this.state.sex === 2 && years >= 12 && years <= 65;
        const web = RX.Platform.getType() === 'web';

        if (web && !this.state.validated) {
            const controls = [
                { control: this.state.dob, labelID: 'DatePickerLabel' },
                { control: this.state.sex, labelID: 'sex' },
                { control: this.state.text, labelID: 'inputLabel' },
                { control: this.state.Q1, labelID: 'Q1' },
                { control: this.state.Q2, labelID: 'Q2' },
                { control: this.state.Q3, labelID: 'Q3' },
                { control: this.state.Q4, labelID: 'Q4' },
                { control: this.state.Q5, labelID: 'Q5' },
                { control: this.state.Q6, labelID: 'Q6' },
                { control: this.state.Q7, labelID: 'Q7' },
            ];
            for (const element of controls) {
                if (!element.control) {
                   //  alert(element.labelID);
                   // tslint:disable-next-line:no-console
                    console.log(this.state.showControlsError);
                    const tess = web && document.getElementById(element.labelID);
                    const ooooo = web && tess && tess.scrollIntoView();
                    this.setState({ showControlsError: true})
                    this.valueChange({ value: element.control, key: element.labelID });
                    return;
                }
            }
            return;
        }

        dispatch({ type: 'STORE_VALUES', ...this.state });
        dispatch({ type: 'SUBMITTING' });

        this.setState({ submitting: true });

        const timer = setTimeout(this.timedOut, 10000); //tslint:disable-line

        axios({
            data: {
                ...this.state,
                code: 1,
                message: 'some message',
                pregnant: this.state.pregnancy,
                region: 12,
                symptoms: this.state.text,
                web_service: 'json',
            },
            headers: {
                'Access-Control-Allow-Origin': '*'
            },
            method: 'POST',
            url: symptomDiagnosis,
        }).then((response: any) => {
            if (response && response.status === 204) {
                ReactGA.trackEvent('Symptoms', 'No Results');
                dispatch({ type: 'SUBMITTED' });
                const inputLabel = web && document.getElementById('inputLabel');
                web && inputLabel && inputLabel.scrollIntoView(); //tslint:disable-line
                !web && scroller && scroller({ x: 0, y: moreSpace ? 500 : 425 })//tslint:disable-line
                dispatch({ type: 'SHOW_POPUP', children: <RX.Text style={{ fontSize: 14 * this.props.window.multiplier }}>The symptoms you entered did not return any results.  Please refine your query, and check your spelling and terminology.</RX.Text>, onClose: this.props.textInput.focus }); //tslint:disable-line
            } else {
                dispatch({ type: 'SUBMITTED' });
                dispatch({ type: 'WHERE_TO', ...response.data });
                openUrl('/results', '_self');
            }
            clearInterval(timer);
        }).catch((error) => {
            dispatch({ type: 'SUBMITTED' });
            if (error.message && error.message === 'Network Error') {
                dispatch({ type: 'SHOW_POPUP', children: <RX.Text style={{ fontSize: 14 * this.props.window.multiplier }}>The application is currently offline. Please check your internet connection and try again.</RX.Text> }); //tslint:disable-line
            }

            clearInterval(timer);
        })
    }

    private timedOut() {
        this.props.dispatch({ type: 'SUBMITTED' });
        this.props.dispatch({ type: 'SHOW_POPUP', children: <RX.Text style={{ fontSize: 14 * this.props.window.multiplier }}>The application is currently offline. Please check your internet connection and try again.</RX.Text> }); //tslint:disable-line
    }

    private validateForm(updatedState: Form) {
        const years = moment().diff(updatedState.dob, 'years');
        const validated = updatedState.Q1 && updatedState.Q2 && updatedState.Q3 && updatedState.Q4 && updatedState.Q5
            && updatedState.Q6 && updatedState.Q7 && updatedState.sex && updatedState.dob && years >= 0
            && updatedState.text && updatedState.text.length > 0 || false;
        this.setState({ validated });
    }
}

export default connect(mapStateToProps)(SymptomChecker);



// WEBPACK FOOTER //
// ./src/pages/symptom_checker/index.tsx